import styled, { css } from 'styled-components'

const Title = styled.div`
  ${({
    theme: {
      colors: { textDefault },
      typography: {
        headings: {
          xlarge: { bundledCSS: xlargeHeadingCSS },
        },
      },
    },
  }) => css`
    color: ${textDefault};
    ${xlargeHeadingCSS}
  `}
`

export default Title
